import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">吃瓜排行</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">实时热度榜单 · 大家都在看</p>
        <div className="max-w-[800px] mx-auto">
          <div className="bg-background-50 rounded-lg border border-background-200 overflow-hidden">
            {rankingData.map((item, idx) => (
              <a
                key={item.id}
                href="#carousel"
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 cursor-pointer hover:bg-primary-50/30 transition-colors group ${
                  idx < rankingData.length - 1 ? 'border-b border-background-100' : ''
                }`}
              >
                <span
                  className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                    item.rank === 1
                      ? 'bg-primary-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-background-100 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="flex-1 text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                <span className={`flex items-center gap-0.5 text-xs whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-500' : 'text-secondary-500'
                }`}>
                  <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-xs`}></i>
                  {item.change}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}